import { SortType } from "fe-common/graphql";
import { getQueryParams } from "fe-common/useQueryParams";

const queryParams = getQueryParams();

export const DEFAULT_SORT =
  (queryParams.get("sort_type") as SortType) || SortType.Urgency;
export const pathOptions = { adaptiveGrouping: false };
